<script>
  import Header from "./Header.svelte";
</script>

<div class="container">
  <Header>Statement</Header>

  <div class="statement">
    <p>
      In Jasmine Venes's textile works, she investigates the liminal spaces
      between architectural presence and natural ephemera, creating dialectics
      between containment and boundlessness. Her formal vocabulary—arches,
      doorways, horizons—function as both physical and metaphysical thresholds,
      interrogating how constructed frameworks mediate our experience of
      landscape. The tactile nature of fabric adds depth to this experience,
      creating textures that engage both eye and imagination.
    </p>

    <p>
      New Mexico's dramatic interplay of light, space, and structure provides
      the phenomenological foundation for her compositions. The stark geometries
      and atmospheric conditions of the Southwest become both subject and
      conceptual framework, expressing tensions between human-made order and
      natural vastness. By transforming transient elements like clouds and
      shadows into tactile objects, she materializes the immaterial, challenging
      conventional perceptions of permanence.
    </p>

    <p>
      Venes's process moves deliberately from photographic documentation through
      digital modeling to textile manifestation—a transmutation across mediums
      that mirrors the translation between exterior and interior space her work
      explores. Through these material investigations, she seeks to create
      environments where architectural language opens into questions of
      presence, perception, and belonging within the contemporary landscape.
    </p>
  </div>
</div>

<style>
  .container {
    display: flex;
    align-items: center;
    flex-direction: column;
    overflow: none;
    height: 100vh;
  }
  .statement {
    color: white;
    padding: 2rem 2rem 12rem 2rem;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    font-size: 1.1rem;
    height: 100%;
    overflow-y: auto;
    max-width: 40rem;
  }
  p {
    margin: 0;
  }
</style>
